import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import API_BASE_URL from "../../../../../../../Constants";
import DirectorPanel from "./DirectorPanel";
import { findOwnerProfileByEmail } from "./directorService";

const XRMPanel = ({ onLoginSuccess }) => {
  const [error, setError] = useState(null);
  const [loginSuccessful, setLoginSuccessful] = useState(false);
  const [selectedDirector, setSelectedDirector] = useState(null);
  const [lookingUpEmail, setLookingUpEmail] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLookingUpEmail(true);

    try {
      if (!selectedDirector || !selectedDirector.id || !selectedDirector.email) {
        throw new Error("Please select a director first.");
      }

      // Step 1: Login using the approach from SingleStepScrape
      const authRes = await fetch(`${API_BASE_URL}/api/inspections/posting/login`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          id: String(selectedDirector.id),
          email: selectedDirector.email,
        }),
        credentials: "include",
      });

      if (!authRes.ok) {
        throw new Error(`Authentication failed for director #${selectedDirector.id}`);
      }

      const loginJson = await authRes.json();
      if (!loginJson.success) {
        throw new Error(`Authentication error: ${loginJson.error || "Unknown error"}`);
      }

      const authToken = loginJson.session?.authToken;
      const systemUser = loginJson.session?.contactGuid;

      if (!authToken || !systemUser) {
        throw new Error("Failed to retrieve authentication credentials");
      }

      // Step 2: Find owner profile by email for address information
      const ownerProfile = await findOwnerProfileByEmail(selectedDirector.email);

      // Step 3: Create a structure similar to the previous XRM response format
      // but using the data from the new login approach + owner profile
      const enhancedData = {
        contact: [{
          AuthToken: authToken,
          ContactID: systemUser,
          // Use owner profile data for address fields if available, otherwise empty strings
          BusinessAddress: ownerProfile?.street || "",
          City: ownerProfile?.city || "",
          State: ownerProfile?.state || "",
          Zip: ownerProfile?.zip || ""
        }]
      };
      
      setLoginSuccessful(true);
      if (onLoginSuccess) {
        onLoginSuccess(enhancedData);
      }
    } catch (err) {
      setError(err.message || "An unexpected error occurred.");
    } finally {
      setLookingUpEmail(false);
    }
  };

  return (
    <div className="p-4">
      <DirectorPanel
        selectedDirector={selectedDirector}
        setSelectedDirector={setSelectedDirector}
      />
      <div className="mt-4">
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          color="primary"
          disabled={lookingUpEmail || !selectedDirector}
        >
          {lookingUpEmail ? "Processing..." : "Login"}
        </Button>
      </div>
      {error && (
        <Box display="flex" alignItems="center" mt={2}>
          <Typography color="error">{error}</Typography>
        </Box>
      )}
      {loginSuccessful && (
        <Box display="flex" alignItems="center" mt={2}>
          <Box
            display="flex"
            alignItems="center"
            p={1}
            bgcolor="success.light"
            color="white"
            borderRadius={1}
          >
            <CheckCircleIcon />
            <Typography ml={1}>Login successful</Typography>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default XRMPanel;
